/*=========================================================================================
  File Name: paymentRequestTemplate.js
  Description: Payment Request
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./paymentRequestTemplateState";
import mutations from "./paymentRequestTemplateMutation";
import actions from "./paymentRequestTemplateActions";
import getters from "./paymentRequestTemplateGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
